import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import styles from "./Transaction.m.scss";

const SORT_SYMBOLS = {
  ASC: "↑",
  DSC: "↓",
};

function TransactionHeader(props) {
  const { theme, setFilter, sortById, sortByDate } = props;

  return (
    <div className={classnames(theme.header)}>
      <div
        className={classnames(theme["sort-link"])}
        onClick={() => {
          let value;
          if (sortById === "DSC") {
            value = null;
          } else if (sortById === "ASC") {
            value = "DSC";
          } else {
            value = "ASC";
          }
          setFilter({ id: "sortById", value }, true);
        }}
      >
        <div>{"Id" + (sortById ? " " + SORT_SYMBOLS[sortById] : "")}</div>
      </div>
      <div>{"Платежная система"}</div>
      <div>{"PAN"}</div>
      <div>{"Код авторизации"}</div>
      <div
        className={classnames(theme["sort-link"])}
        onClick={() => {
          let value;
          if (sortByDate === "DSC") {
            value = null;
          } else if (sortByDate === "ASC") {
            value = "DSC";
          } else {
            value = "ASC";
          }
          setFilter({ id: "sortByDate", value }, true);
        }}
      >
        <div>
          {"Дата обработки" +
            (sortByDate ? " " + SORT_SYMBOLS[sortByDate] : "")}
        </div>
      </div>
      <div>{"Сумма операции"}</div>
      {/* <div /> */}
      <div>{"Комиссия"}</div>
      {/* <div /> */}
      <div>{"Точка обслуживания"}</div>
      <div>{"Тип транзакции"}</div>
      {/* <div>{"Статус"}</div> */}
      <div>{"Статус SMS"}</div>
      {/* <div>{"Дата из терминала"}</div> */}
    </div>
  );
}

TransactionHeader.displayName = "TransactionHeader";

TransactionHeader.propTypes = {
  theme: PropTypes.object,
  setFilter: PropTypes.func,
  sortById: PropTypes.string,
  sortByDate: PropTypes.string,
};

TransactionHeader.defaultProps = {};

export default themr("@lifepay/TransactionHeader", styles)(TransactionHeader);



// WEBPACK FOOTER //
// ./src/components/list-items/compact/Transaction/Header.js